"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyFieldLogic = void 0;
var dependency_fieldtype_1 = require("./dependency.fieldtype");
Object.defineProperty(exports, "DependencyFieldLogic", { enumerable: true, get: function () { return dependency_fieldtype_1.DependencyFieldLogic; } });
